import "./App.css";
import { Route, Switch, BrowserRouter, Router } from "react-router-dom";
import BenhHiemNgheo from "./components/bh-benh-hiem-ngheo";
import History from "./routes/history";
function App() {
  return (
    <BrowserRouter >
      <Router history={History}>
        <Switch>
          <Route component={BenhHiemNgheo} path="*" />
        </Switch>
      </Router>
    </BrowserRouter>
  );
}

export default App;
